import {ApplicationConfig, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {PreloadAllModules, provideRouter, withPreloading} from '@angular/router';

import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {MAT_DATE_LOCALE, provideNativeDateAdapter} from '@angular/material/core';
import {providePrimengCore} from 'src/app/core/common/primeng.provider';
import {provideSwaggerCore} from 'src/app/core/swagger/swagger.provider';
import {provideAppStore} from 'src/app/core/common/store.provider';
import {provideAppLegacyModules} from 'src/app/core/common/legacy.modules.provider';
import {provideAppLegacyServices} from 'src/app/core/common/legacy.services.providers';
import {routes} from 'src/app/app.routes';
import {OKTA_AUTH} from '@okta/okta-angular';
import {OktaModule} from 'src/app/tinea-components/okta/okta/okta.module';
import {oktaAuth} from 'src/app/tinea-components/okta/okta/configuration/okta';
import {AuthenCubeJsService} from 'src/app/tinea-components/okta/auth/services/authen-cubejs.service';
import {CubejsClient} from '@cubejs-client/ngx';
import {provideEchartsCore} from 'ngx-echarts';
import {DatePipe} from '@angular/common';
import {provideTranslateService} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';

const cubesClientFactory = (authService: AuthenCubeJsService) => {
  return new CubejsClient(authService.config$);
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimationsAsync(),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules)
    ),
    importProvidersFrom(OktaModule),
    {
      provide: OKTA_AUTH,
      useValue: oktaAuth
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'fr-FR'
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService({
      loader: provideTranslateHttpLoader({ prefix: '/i18n/' })
    }),
    provideAnimationsAsync(),
    provideNativeDateAdapter(),
    provideAnimationsAsync(),
    providePrimengCore(),
    {
      provide: CubejsClient,
      useFactory: cubesClientFactory,
      deps: [AuthenCubeJsService],
    },
    provideEchartsCore({echarts: () => import('echarts')}),
    ...provideSwaggerCore(),
    ...provideAppLegacyModules(),
    ...provideAppLegacyServices(),
    ...provideAppStore(),
    DatePipe,
  ]
};
